import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { resolvePageTitleKey } from '@/lib/constants/pageTitles';

/**
 * Keeps `document.title` in sync with the current route, in the active
 * language — it re-runs on navigation and on a language switch.
 * Mounted once at the router root.
 */
export function useDocumentTitle() {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    const appName = t('common:app.name');
    const titleKey = resolvePageTitleKey(pathname);

    document.title = titleKey ? `${t(titleKey)} · ${appName}` : appName;
  }, [pathname, t, i18n?.language]);
}
